var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('div',{staticClass:"main-wrap my-account"},[_c('div',{staticClass:"support-title"},[_vm._v("Customer Support")]),_c('div',{staticClass:"tab"})])])
}]

export { render, staticRenderFns }